import { render } from "./IndustryAndInterest.vue?vue&type=template&id=56073044"
import script from "./IndustryAndInterest.vue?vue&type=script&lang=js"
export * from "./IndustryAndInterest.vue?vue&type=script&lang=js"

import "./IndustryAndInterest.vue?vue&type=style&index=0&id=56073044&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__